/**
 * Thin client for two_joint_pole_gm solo session APIs (Option B 1P).
 * Multiplayer keeps using /session/* on the same GM (:5090 / CRA /tjp).
 */
import { ARCADE, API_PATH_PROXY_ENABLED } from '../../../utils/config';
import { acquireGmLease, endGmSession, noteGmState } from '../gmLease';

/** Lease key for this game's shared GM (game_engines/gm_registry.py). */
export const GM_GAME_ID = 'two_joint_pole';

export const TJP_GM_BASE = API_PATH_PROXY_ENABLED
    ? (ARCADE.two_joint_pole?.API_BASE || '')
    : '/tjp';

async function parseJson(res) {
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
        const err = new Error(data.error || `TJP GM HTTP ${res.status}`);
        err.status = res.status;
        err.data = data;
        throw err;
    }
    return noteGmState(GM_GAME_ID, data);
}

export async function createTjpSoloSession(params = {}) {
    await acquireGmLease(GM_GAME_ID);
    const body = {
        stiffness: params.stiffness,
        gravity: params.gravity,
        pole_mass: params.poleMass ?? params.pole_mass,
        preset: params.preset,
    };
    const res = await fetch(`${TJP_GM_BASE}/solo/session/create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
    });
    return parseJson(res);
}

export async function moveTjpSoloSession(sessionId, action = 'stay') {
    const res = await fetch(`${TJP_GM_BASE}/solo/session/${sessionId}/move`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action }),
    });
    return parseJson(res);
}

export async function deleteTjpSoloSession(sessionId) {
    if (!sessionId) return;
    endGmSession(GM_GAME_ID, sessionId);
    try {
        await fetch(`${TJP_GM_BASE}/solo/session/${sessionId}/delete`, { method: 'POST' });
    } catch {
        /* best-effort */
    }
}

export const DT = 0.02;
